import React, { useState,useEffect } from 'react';
import { useHistory } from 'react-router';
import s_title from './img/s_title.png';
import s1 from './img/s1.png';
import s1_1 from './img/s1_1.png';
import s2 from './img/s2.png';
import s2_1 from './img/s2_1.png';
import s3 from './img/s3.png';
import s3_1 from './img/s3_1.png';
import queryString from 'query-string';
import { comma } from './common';
import sun_1 from './img/sun_1.png';
import sun_2 from './img/sun_2.png';
import sun_3 from './img/sun_3.png';

import ray1 from './img/ray1.png';
import ray2 from './img/ray2.png';
import ray3 from './img/ray3.png';




function SunList(props){
    console.log('props : ', props)
    const history = useHistory();
    const [type, setType] = useState('');
    const [carType, setCarType] = useState('');
    
    const [front , setFront] = useState('');
    const [side , setSide] = useState('');
    const [blackbox , setBlackbox] = useState('');
    const [plus , setPlus] = useState('');
    const [plusPrice , setPrice] = useState(0);

    const [defaultData, setDefault] = useState([
        {
            type:'SMART',
            front:['썬가드 하이퍼 MX'],
            side:['썬가드 하이퍼 MX'],
            blackbox:['고급 FHD-FHD 아이나비 Z5000 Plus (32GB)','고급 FHD-FHD 파인뷰 LX 5000 (32GB)']
        },
        {
            type:'Premium',
            front:['썬가드 하이퍼 MH'],
            side:['썬가드 하이퍼 MH'],
            blackbox:['고급 FHD-FHD 아이나비 Z5000 Plus (32GB)','고급 FHD-FHD 파인뷰 LX 5000 (32GB)']
        },
        {
            type:'Prestige',
            front:['썬가드 하이퍼 MS','썬가드 하이퍼 MR(반사)'],
            side:['썬가드 하이퍼 MS','썬가드 하이퍼 MR(반사)'],
            blackbox:['고급 FHD-FHD 아이나비 Z5000 Plus (32GB)','고급 FHD-FHD 파인뷰 LX 5000 (32GB)']
        },
    ])

    const plusChange = (e) => {
        const {value} = e.target;
        const {price} = e.target.options[e.target.selectedIndex].dataset;
        setPlus(value)
        setPrice(Number(price));
    }

    const frontChange = (e) => {
        const {value} = e.target;
        setFront(value);
    }

    const sideChange = (e) => {
        const {value} = e.target;
        setSide(value);
    }

    const boxChange = (e) => {
        const {value} = e.target;
        setBlackbox(value);
    }

    console.log('plus : ', plus)
    console.log('front : ', front)
    console.log('plusPrice : ', plusPrice)
    console.log('defaultData : ', defaultData)
    

    const [data, setData] = useState([
        {
            cate:'sun',
            type:'SMART',
            car:'casper',
            product	: '',
            s_price : 730000,
            d_price : 499000,
            img: s1
        },
        {
            cate:'sun',
            type:'Premium',
            car:'casper',
            product	: '',
            s_price : 1030000,
            d_price : 599000,
            img: s2
        },
        {
            cate:'sun',
            type:'Prestige',
            car:'casper',
            product	: '',
            s_price : 1380000,
            d_price : 699000 ,
            img: s3
        },
        {
            cate:'sun',
            type:'SMART',
            car:'ray',
            product	: '',
            s_price : 730000,
            d_price : 499000,
            img: ray1
        },
        {
            cate:'sun',
            type:'Premium',
            car:'ray',
            product	: '',
            s_price : 1030000,
            d_price : 599000,
            img: ray2
        },
        {
            cate:'sun',
            type:'Prestige',
            car:'ray',
            product	: '',
            s_price : 1380000,
            d_price : 699000 ,
            img: ray3
        },
    ]);


    const [bgUrl , setbgUrl] = useState([
        {
            type:'SMART',
            car:'casper',
            src1:s1,
            src2:s1_1
        },
        {
            type:'Premium',
            car:'casper',
            src1:s2,
            src2:s2_1
        },
        {
            type:'Prestige',
            car:'casper',
            src1:s3,
            src2:s3_1
        },
        {
            type:'SMART',
            car:'ray',
            src1:ray1,
            src2:s1_1
        },
        {
            type:'Premium',
            car:'ray',
            src1:ray2,
            src2:s2_1
        },
        {
            type:'Prestige',
            car:'ray',
            src1:ray3,
            src2:s3_1
        },
    ])

    useEffect(()=> {
  
        setType(queryString.parse(history.location.search).type)
        setCarType(queryString.parse(history.location.search).car)
        props.setBannerType('')

    },[bgUrl])

    console.log('data : ', data)

    const onClick = () => {
        if(!window.sessionStorage.result){
            alert('로그인 후 이용이 가능합니다.');
            history.push('/login');
        }else{
            if(!front){
                alert('썬팅 전면을 선택해주세요.');
                return false;
            }else if(!side){
                alert('썬팅 측후면을 선택해주세요.');
                return false;
            }else if(!blackbox){
                alert('블랙박스를 선택해주세요.');
                return false;
            }else{
                const filterData = data.filter(v => v.type === type && v.car === carType)
                let plusStr = '';
                if(plus){
                    plusStr = ',';
                }
                filterData[0].product = front + ',' + side + ',' + blackbox + plusStr + plus;
                // filterData[0].plus = plus;
                // filterData[0].plusPrice = plusPrice;
                filterData[0].d_price = filterData[0].d_price + plusPrice;
                filterData[0].car = carType;
                console.log('filterData : ', filterData[0])
                history.push('/cart?data='+JSON.stringify(filterData))
            }
            
        }
    }
    return (
        <>
        <div className="text-center container py-5">
            <img className="w-100" src={s_title} style={{maxWidth:"700px"}}/>
        </div>
        <div className="text-center" style={{backgroundColor:'#EFEFEF'}}>
            <div className="row mx-auto py-5 px-0" style={{maxWidth:"850px"}}>
                <div className="col-12 col-md-6">
                {
                    bgUrl.map((v,i) => (v.type === type && v.car === carType) && <img key={i} className="w-100" src={v.src1} />)
                }

                </div>
                <div className="col-12 col-md-6 text-left">
                {
                    bgUrl.map((v,i) => (v.type === type && v.car === carType) && 
                        <>
                        <p className="font-weight-bold" style={{fontSize:'28px'}}>{v.type}형 <span  style={{fontSize:'16px'}}>썬팅+블랙박스</span></p>
                        <span className="d-inline-block sun-btn mb-3">기본 옵션(필수)</span>
                        <select type="text" className="form-control mb-3" onChange={frontChange}>
                            <option value="">썬팅-전면</option>
                            {
                                defaultData.map(items => items.type === type && 
                                    items.front.map((vv,ii) => <option value={vv} key={ii}>{vv}</option>)
                                )
                            }
                        </select>

                        <select type="text" className="form-control mb-3" onChange={sideChange}>
                            <option value="">썬팅-측후면</option>
                            {
                                defaultData.map(items => items.type === type && 
                                    items.side.map((vv,ii) => <option value={vv} key={ii}>{vv}</option>)
                                )
                            }
                        </select>

                        <select type="text" className="form-control mb-3" onChange={boxChange}>
                            <option value="">블랙박스</option>
                            {
                                defaultData.map(items => items.type === type && 
                                    items.blackbox.map((vv,ii) => <option value={vv} key={ii}>{vv}</option>)
                                )
                            }
                        </select>

                        <span className="d-inline-block sun-btn mb-3">추가 옵션(선택)</span>
                        <select type="text" className="form-control" onChange={plusChange}>
                            <option value="" data-price="0">선택</option>
                            <option value="블랙박스 메모리카드 64G 업그레이드" data-price="30000">블랙박스 메모리카드 64G 업그레이드 (+30,000)</option>
                            <option value="블랙박스 아이나비 QXD 7000 업그레이드" data-price="150000">블랙박스 아이나비 QXD 7000 업그레이드 (+150,000)</option>
                            <option value="(스마트-Ⅰ)유리막코팅 H30 + PPF4종" data-price="130000">(스마트-Ⅰ)유리막코팅 H30 + PPF4종 (+130,000)</option>
                            <option value="(스마트-Ⅱ)유리막코팅 H30 + PPF4종 + 헤드업 디스플레이 (T-HUB) T-202" data-price="200000">(스마트-Ⅱ)유리막코팅 H30 + PPF4종 + 헤드업 디스플레이 (T-HUB) T-202 (+200,000)</option>
                            <option value="(Premium Choice-Ⅰ)유리막코팅 X30 + PPF4종" data-price="180000">(Premium Choice-Ⅰ)유리막코팅 X30 + PPF4종 (+180,000)</option>
                            <option value="(Premium Choice-Ⅱ)유리막코팅 X30 + PPF4종 + 헤드업 디스플레이 (T-HUB) T-202" data-price="250000">(Premium Choice-Ⅱ)유리막코팅 X30 + PPF4종 + 헤드업 디스플레이 (T-HUB) T-202 (+250,000)</option>
                        </select>
                        <p className="my-3 font-weight-bold">- ABYS So Good Service 무상제공</p>
                        <div className="text-right mt-5">
                            <p className="font-weight-bold" style={{fontSize:'20px'}}>총 금액 : {data.map(p => (p.type === type && p.car === carType) && <span style={{fontSize:'27px',color:'#D71A1D'}}>{comma(p.d_price + plusPrice)}</span>)}원</p>
                            <span className="d-inline-block sun-btn pointer" onClick={onClick}>서비스 신청하기</span>
                        </div>
                        </>
                    )
                }
                    
                </div>
                
            </div>
        </div>
        <div className="container text-center">
            {
                bgUrl.map((v,i) => (v.type === type && v.car === carType) && <img key={i} className="w-100" src={v.src2} style={{maxWidth:"900px"}}/>)
            }
        </div>
        </>
    )
}

export default SunList;